import type { StatusDefinition } from "@kontextwerk/web-sdk/core/display/status"
import {
  mdiCalendarCheckOutline,
  mdiCalendarClockOutline,
  mdiCheckBold,
  mdiClipboardTextClockOutline,
  mdiCloseCircleOutline,
  mdiHandshakeOutline,
  mdiPlusCircleOutline,
} from "@mdi/js"
import {
  workOrderStatusDescriptions,
  workOrderStatusLabels,
  type WorkOrderViewStatus,
} from "../../../../../../../_shared/_logic/outreach-presentation"

export const workOrderStatuses: StatusDefinition<WorkOrderViewStatus>[] = [
  {
    value: "ANNOUNCED",
    label: "Termin angekündigt",
    color: "forest",
    icon: mdiCalendarClockOutline,
    description: "Der Termin wurde angekündigt; eine Kundenbestätigung steht noch aus.",
  },
  {
    value: "NEW",
    label: workOrderStatusLabels.NEW,
    icon: mdiPlusCircleOutline,
    color: "blue",
    description: workOrderStatusDescriptions.NEW,
  },
  {
    value: "IN_PLANNING",
    label: workOrderStatusLabels.IN_PLANNING,
    icon: mdiClipboardTextClockOutline,
    color: "amber",
    description: workOrderStatusDescriptions.IN_PLANNING,
  },
  {
    value: "PLANNED",
    label: workOrderStatusLabels.PLANNED,
    icon: mdiCalendarClockOutline,
    color: "orange",
    description: workOrderStatusDescriptions.PLANNED,
  },
  {
    value: "IN_AGREEMENT",
    label: workOrderStatusLabels.IN_AGREEMENT,
    icon: mdiHandshakeOutline,
    color: "blue",
    description: workOrderStatusDescriptions.IN_AGREEMENT,
  },
  {
    value: "AGREED",
    label: workOrderStatusLabels.AGREED,
    icon: mdiCheckBold,
    color: "emerald",
    description: workOrderStatusDescriptions.AGREED,
  },
  {
    value: "COMPLETED",
    label: workOrderStatusLabels.COMPLETED,
    icon: mdiCalendarCheckOutline,
    color: "emerald",
    description: workOrderStatusDescriptions.COMPLETED,
  },
  {
    value: "FAILED",
    label: workOrderStatusLabels.FAILED,
    icon: mdiCloseCircleOutline,
    color: "red",
    description: workOrderStatusDescriptions.FAILED,
  },
]

export const workOrderStatusByCode: Record<
  WorkOrderViewStatus,
  StatusDefinition<WorkOrderViewStatus>
> = Object.fromEntries(workOrderStatuses.map((entry) => [entry.value, entry])) as Record<
  WorkOrderViewStatus,
  StatusDefinition<WorkOrderViewStatus>
>
